import React from "react"
import styled from "styled-components"

const StyledWrapper = styled.div`
    position: relative;
    background-color: ${(props) => props.theme.color.darkGrey};
    color: ${(props) => props.theme.color.white};
    height: 1rem;
    width: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 2px;
    font-size: 0.7rem;
    font-weight: 600;

    &:hover {
        cursor: pointer;
        background-color: ${(props) => props.theme.color.dimGrey};
    }
`

const QuestionIcon = ({ handleClick, children }) => {
    return (
        <StyledWrapper onClick={() => handleClick()}>?{children}</StyledWrapper>
    )
}

export default QuestionIcon
